/* eslint-disable import/prefer-default-export */
import {createAsyncThunk} from '@reduxjs/toolkit';
import omitEmpty from '../utils/omitEmpty';
import fetchRequest from './utils';

export const getAllRateLimits = createAsyncThunk('rateLimits/getAllRateLimits', async (params) => {
    const query = omitEmpty({
        description: params.description,
        appAwareTierIds: params.appAwareTierIds
    });

    return fetchRequest('/rate-limits', 'GET', query);
});

export const getRateLimitById = createAsyncThunk('rateLimits/getRateLimitById', async (id) => fetchRequest(`/rate-limits/${id}`, 'GET'));
